var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusPermission } from '../../../enum';
import { InputLabel } from '../../common/formField';
import { CopyDataFrom } from '../common/copyDataFrom';
import { WizardStep } from '../constants';
import { useRefreshQueueData } from '../queue/selectors';
import { QueueStatusType } from '../queue/types';
import { useEffectiveCapacityPermission, useIsPlanLocked, useWizardParams } from '../selectors';
import { useClearVolumeAPI, useCopyVolumeAPI } from '../workVolume/selectors';
import { WorkingDaysBaseTable } from './workingDaysBaseTable';
export var FteForm = function () {
  var t = useTranslation('wizard', {
    keyPrefix: 'workingDay'
  }).t;
  var capacityPermission = useEffectiveCapacityPermission();
  var isPlanLocked = useIsPlanLocked();
  var disabled = capacityPermission !== StatusPermission.Edit || isPlanLocked;
  var step = useWizardParams().step;
  var refreshData = useRefreshQueueData();
  var _a = useCopyVolumeAPI(QueueStatusType.FTEDay),
    copiedData = _a[0],
    copyData = _a[1],
    clearCopiedData = _a[2];
  var _b = useClearVolumeAPI(QueueStatusType.FTEDay),
    clearedData = _b[0],
    clearData = _b[1],
    cleanClearedData = _b[2];
  var isReview = step === WizardStep.Review;
  useEffect(function () {
    if (clearedData.data || copiedData.data) {
      refreshData();
    }
    return function () {
      cleanClearedData();
      clearCopiedData();
    };
  }, [cleanClearedData, clearCopiedData, clearedData.data, copiedData.data, refreshData]);
  var handleCopy = function (source) {
    copyData(source);
  };
  var handleClear = function () {
    clearData();
  };
  return _jsxs(Stack, __assign({
    paddingTop: 3
  }, {
    children: [_jsxs(Stack, __assign({
      direction: "row",
      justifyContent: "space-between"
    }, {
      children: [_jsxs(Box, __assign({
        width: {
          xs: '50%',
          md: '75%'
        }
      }, {
        children: [_jsx(InputLabel, __assign({
          required: !isReview,
          sx: {
            mb: 2,
            fontSize: function (theme) {
              return theme.typography.pxToRem(18);
            }
          }
        }, {
          children: t('fteForm.title')
        })), !isReview && _jsx(Typography, __assign({
          variant: "body1",
          gutterBottom: true,
          paddingBottom: 2
        }, {
          children: t('fteForm.description')
        }))]
      })), !isReview && _jsx(CopyDataFrom, {
        statusType: QueueStatusType.FTEDay,
        onCopy: handleCopy,
        onClear: handleClear,
        needSaveBeforeCopy: true,
        disabled: disabled
      })]
    })), _jsx(WorkingDaysBaseTable, {
      isFte: true,
      disabled: disabled
    })]
  }));
};